/** A short accent helps people spot accepted additions and edits without leaving a permanent status colour. */
export const RECENT_MEMORY_MS = 24 * 60 * 60 * 1000;

export type MemoryRecency = "new" | "updated" | null;

export function memoryRecency(
  createdAt: string | undefined,
  updatedAt: string | undefined,
  now: number,
): MemoryRecency {
  const created = createdAt ? Date.parse(createdAt) : NaN;
  const updated = updatedAt ? Date.parse(updatedAt) : NaN;
  const changed = Number.isFinite(updated) ? updated : created;
  if (
    !Number.isFinite(changed) ||
    changed > now ||
    now - changed >= RECENT_MEMORY_MS
  )
    return null;
  return Number.isFinite(created) && updated - created > 60_000
    ? "updated"
    : "new";
}
